import { render, staticRenderFns } from "./MenuOptionsNavigation.vue?vue&type=template&id=2c633ff1&scoped=true"
import script from "./MenuOptionsNavigation.vue?vue&type=script&lang=js"
export * from "./MenuOptionsNavigation.vue?vue&type=script&lang=js"
import style0 from "./MenuOptionsNavigation.vue?vue&type=style&index=0&id=2c633ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c633ff1",
  null
  
)

export default component.exports